import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { emailToDomain } from 'utils/misc';
import { isEmpty } from 'lodash';
import { EMAIL_BACKEND_CONFIG } from 'constants/config';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';

import {
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Table,
} from 'reactstrap';
import Alert from 'components/Alert';


const DnsRow = (dns, errorsVerifying = []) => {
  const hasError = !isEmpty(errorsVerifying.filter(e => e.includes(dns.record_name)));
  return (
    <tr>
      <td>
        {hasError && <AlertOutlineIcon className="invalid_dns_record" />}
        {dns.record_type.toUpperCase()}
      </td>
      <td><textarea className="form-control" disabled defaultValue={dns.record_name} /></td>
      <td><textarea className="form-control" disabled defaultValue={dns.record_value} /></td>
    </tr>
  );
};

const DnsErrors = errors => (
  <Alert color="warning">
    {errors.map(error => (
      <div className="textLeft">- {error}</div>
    ))}
  </Alert>
);

class EmailVerificationModal extends React.Component {
  static propTypes = {
    emailSetting: PropTypes.arrayOf(PropTypes.shape({
      dns: PropTypes.shape({
        record_name: PropTypes.string,
        record_type: PropTypes.string,
        record_value: PropTypes.string,
      }),
      email: PropTypes.string,
    })),
    errorsVerifying: PropTypes.shape({}).isRequired,
    isOpen: PropTypes.bool.isRequired,
    backdropClassName: PropTypes.string,
    onSuccess: PropTypes.func.isRequired,
    config: PropTypes.shape({
      emailBackend: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    backdropClassName: '',
    emailSetting: {},
  };

  handleDestroy = () => {
    this.props.onSuccess();
  }

  render() {
    const {
      isOpen,
      emailSetting,
      config,
      errorsVerifying,
    } = this.props;
    const { espTxtValue } = config.emailBackend
      ? EMAIL_BACKEND_CONFIG[config.emailBackend]
      : '';

    const domain = emailToDomain(emailSetting.email || '');
    return (
      <Modal
        isOpen={isOpen}
        className="email-verification-modal"
        backdropClassName={this.props.backdropClassName}
        disableEnforceFocus
      >
        <ModalHeader className="text-center">
          Make sure to add the below DNS records to your domain:
        </ModalHeader>
        <ModalBody>
          <Table className="volt-table table__details" size="sm" borderless>
            <thead>
              <tr>
                <th>Record Type</th>
                <th>Hostname</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>TXT</td>
                <td><textarea className="form-control" disabled defaultValue={domain} /></td>
                <td><textarea className="form-control" disabled defaultValue={espTxtValue} /></td>
              </tr>
              {emailSetting.dns && emailSetting.dns.map(d => DnsRow(d, errorsVerifying))}
            </tbody>
          </Table>
          {!isEmpty(errorsVerifying) && DnsErrors(errorsVerifying)}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.handleDestroy}>OK</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect(state => ({
  config: state.config,
}))(EmailVerificationModal);
